import { createAction, props } from '@ngrx/store';
import { Document, RelatedDocument, RelatedDocumentCountsByDataset } from 'src/app/modules/core/store/models';
import { Dataset, DatasetMappings, DatasetSubtype, DatasetType } from 'src/app/modules/core/store/models/dataset.model';
import { View } from 'src/app/modules/core/store/models/workflow.model';
import { Layer } from '../cop/models';

// rsd actions
export const newDocument = createAction('[COP/RSD] New Document', props<{ datasetUId?: string }>());
export const setNewDocumentToStore = createAction('[COP/RSD] Set New Document to Store');
export const cancelNewDocument = createAction('[COP/RSD] Cancel New Document');
export const setNewDocumentDataset = createAction('[COP/RSD] Set New Document Dataset', props<{ dataset: Dataset }>());
export const editDocument = createAction('[COP/RSD] Edit Document');
export const cancelEditDocument = createAction('[COP/RSD] Cancel Edit Document');

export const setSelectedDocument = createAction(
  '[COP/RSD] Set Selected Document',
  props<{
    layerUId: string;
    documentUId: string;
    isDrawerOpen: boolean;
    replaceStack: boolean;
    edit?: boolean;
    backAction?: string;
    overrides?: {
      uId?: {
        datasetUId?: string;
        documentUId?: string;
      };
      additionalDocumentData?: {
        [key: string]: any;
      };
    };
  }>()
);

export const pushDocumentStateStack = createAction(
  '[COP/RSD] Push Document State Stack',
  props<{
    dataset: Dataset;
    layer?: Layer;
    document: Document;
    editView: View;
    isDrawerOpen: boolean;
    replaceStack: boolean;
    edit?: boolean;
    backAction?: string;
  }>()
);
export const popDocumentStateStack = createAction('[COP/RSD] Pop Document State Stack');

export const showDrawer = createAction('[COP/RSD] Show Drawer');
export const hideDrawer = createAction('[COP/RSD] Hide Drawer', props<{ clearDocumentStack: boolean }>());
export const saveDocument = createAction('[COP/RSD] Save Document', props<{ dataset: Dataset; document: Document }>());
export const createDocument = createAction('[COP/RSD] Create Document', props<{ dataset: Dataset; document: Document }>());
export const updateDocument = createAction('[COP/RSD] Update Document', props<{ dataset: Dataset; document: Document }>());
export const saveDocumentComplete = createAction('[COP/RSD] Save Document Complete', props<{ dataset: Dataset; document: Document }>());
export const transitionWorkflow = createAction('[COP/RSD] Transition Workflow', props<{ dataset: Dataset; document: Document }>());
export const transitionWorkflowComplete = createAction(
  '[COP/RSD] Transition Workflow Complete',
  props<{ dataset: Dataset; document: Document }>()
);
export const deleteDocument = createAction('[COP/RSD] Delete Document', props<{ layer: Layer; dataset: Dataset; document: Document }>());

// related docs
export const loadRelatedDatasets = createAction(
  '[COP/RSD] Load Related Datasets',
  props<{ datasetType: DatasetType; datasetSubtype: DatasetSubtype }>()
);
export const loadRelatedDatasetsComplete = createAction('[COP/RSD] Load Related Datasets Complete', props<{ datasets?: Dataset[] }>());
export const createRelatedDocument = createAction('[COP/RSD] Create Related Document', props<{ dataset: Dataset; document: Document }>());
export const createRelatedDocumentComplete = createAction(
  '[COP/RSD] Create Related Document Complete',
  props<{ dataset: Dataset; document: Document }>()
);
export const setRelatedDocumentState = createAction(
  '[COP/RSD] Set Related Document State',
  props<{ dataset: Dataset; document: Document }>()
);
export const setCurrentDocumentState = createAction(
  '[COP/RSD] Set Current Document State',
  props<{ dataset: Dataset; document: Document }>()
);
export const createDatasetRelatedFieldsComplete = createAction(
  '[COP/RSD] Create Related Dataset Fields Complete',
  props<{ fromDataset: Dataset; toDataset: Dataset; toDocument: Document }>()
);
export const loadRelatedDocuments = createAction(
  '[COP/RSD] Load Related Documents',
  props<{ datasetUId?: string;  datasetType?: DatasetType; datasetSubtype?: DatasetSubtype }>()
);
export const initRelatedDocument = createAction(
  '[COP/RSD] Init Related Document',
  props<{ datasetUId?: string; sourceDocument: Document; targetDataset: Dataset; defaultMapping: DatasetMappings }>()
);
export const initRelatedDocumentComplete = createAction('[COP/RSD] Init Related Document Complete', props<{ document?: Document }>());
/*export const setRelatedDocumentsComplete = createAction(
  '[COP/RSD] Set Related Documents Complete',
  props<{ documents?: RelatedDocument[] }>()
);
*/
export const loadRelatedDocumentCountsByDataset = createAction(
  '[COP/RSD] Load Related Document counts by DS',
  props<{ datasetUId: string; documentUId: string }>()
);
export const setRelatedDocumentCountsByDatasetComplete = createAction(
  '[COP/RSD] Set Related Document Counts By Dataset Complete',
  props<{ results?: RelatedDocumentCountsByDataset[] }>()
);

export const openRelatedDocument = createAction(
  '[COP/RSD] Open Related Document',
  props<{ dataset?: Dataset; document?: Document; layerUId?: string }>()
);
export const closeRelatedDocument = createAction('[COP/RSD] Close Related Document');

export const translateSelectedDocument = createAction(
  '[COP/RSD] Translate Selected Document',
  props<{ fromCode: string; toCode: string }>()
);
export const translateSelectedDocumentComplete = createAction(
  '[COP/RSD] Translate Selected Document Complete',
  props<{ document: Document; fromCode: string; toCode: string }>()
);

export const openRelatedTable = createAction(
  '[COP/RSD] Open Related Table',
  props<{ dataset?: Dataset; document?: Document }>()
);
